import { createFileRoute } from '@tanstack/react-router'

import { Reset } from '~/boundedContext/auth/pages/reset'

import { resetSchema } from './-schemas/reset-schema'

export const Route = createFileRoute('/auth/reset-password')({
  component: Reset,
  validateSearch: search => resetSchema.parse(search),
})
